(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/rules/assets/javascripts/rules/system.js') >= 0) return;  svs.modules.push('/components/numbergames/rules/assets/javascripts/rules/system.js');

'use strict';

let Factorial;
if (svs.isServer) {
  const trinidadCore = require('@svenskaspelab/trinidad-core').core;
  Factorial = trinidadCore.components.require('utils', 'math').api.Factorial;
} else {
  Factorial = svs.utils.math.Factorial;
}

function generatedRows(_ref) {
  let {
    numbersLength = 0,
    numbersExtraLength = 0,
    numbersRowSize = 0,
    numbersExtraRowSize = 0
  } = _ref;
  if (numbersLength < numbersRowSize || numbersExtraLength < numbersExtraRowSize) return 0;
  if (numbersLength === numbersRowSize && numbersExtraLength === numbersExtraRowSize) return 1;
  const calculateCombinations = (selectedLength, rowLength) => {
    let numberOfCombinations = Factorial(selectedLength);
    numberOfCombinations /= Factorial(selectedLength - rowLength);
    numberOfCombinations /= Factorial(rowLength);
    return numberOfCombinations;
  };
  const numbersCombinations = calculateCombinations(numbersLength, numbersRowSize);
  const numbersExtraCombinations = calculateCombinations(numbersExtraLength, numbersExtraRowSize);
  return numbersCombinations * numbersExtraCombinations;
}

function systemNumbersLimits(_ref2) {
  let {
    rules,
    combinationSize,
    level
  } = _ref2;
  const {
    NUMBERS
  } = rules.SYSTEM.LIMITS;
  const numberCombination = combinationSize || level;
  if (NUMBERS) {
    return {
      min: NUMBERS.combinationMinLength[numberCombination] || NUMBERS.minRowLength,
      max: NUMBERS.combinationMaxLength[numberCombination] || NUMBERS.maxRowLength
    };
  }
  return {};
}

function systemNumbersExtraLimits(_ref3) {
  let {
    rules,
    combinationSize
  } = _ref3;
  const {
    NUMBERS_EXTRA
  } = rules.SYSTEM.LIMITS;
  if (NUMBERS_EXTRA) {
    return {
      min: NUMBERS_EXTRA.combinationMinLength[combinationSize] || NUMBERS_EXTRA.minRowLength,
      max: NUMBERS_EXTRA.combinationMaxLength[combinationSize] || NUMBERS_EXTRA.maxRowLength
    };
  }
  return {};
}

function systemLimits(_ref4) {
  let {
    rules,
    numberSize,
    numberExtraSize,
    level
  } = _ref4;
  return {
    numbersLimits: systemNumbersLimits({
      rules,
      combinationSize: numberExtraSize,
      level
    }),
    numbersExtraLimits: systemNumbersExtraLimits({
      rules,
      combinationSize: numberSize
    })
  };
}
function systemName(_ref5) {
  let {
    numbersLength,
    numbersExtraLength,
    level
  } = _ref5;
  if (numbersExtraLength) {
    return "System ".concat(numbersLength, " + ").concat(numbersExtraLength);
  }
  if (level) {
    return "System Keno ".concat(level, " | ").concat(numbersLength, " nummer");
  }
  return "System ".concat(numbersLength);
}
function systemDescription(_ref6) {
  let {
    numbersLength,
    numbersExtraLength,
    level,
    rowCount
  } = _ref6;
  if (rowCount > 1) {
    return "".concat(systemName({
      numbersLength,
      numbersExtraLength,
      level
    }), ": ").concat(rowCount, " rader");
  }
  return 'System';
}
if (svs.isServer) {
  module.exports = {
    generatedRows,
    systemNumbersLimits,
    systemNumbersExtraLimits,
    systemLimits,
    systemName,
    systemDescription
  };
} else {
  svs.numbergames.rules.system = {
    generatedRows,
    systemNumbersLimits,
    systemNumbersExtraLimits,
    systemLimits,
    systemName,
    systemDescription
  };
}

 })(window);